<template>
  <div class="tableStyle">
    <div class="tableBox">
      <div class="tableStyle-left">
        <div
          v-show="stateArrow"
          id="leftBox"
          class="leftBox"
          style="width: 206px"
        >
          <vue-draggable-resizable
            :min-width="160"
            @resizing="onResize"
            :max-width="400"
            :draggable="false"
            :handles="['mr']"
            :w="206"
            :parent="false"
          >
            <el-scrollbar>
              <tree
                :isSearch="isSearch"
                @initFun="initQuery"
                @nodeClick="nodeClick"
              ></tree>
            </el-scrollbar>
          </vue-draggable-resizable>
        </div>
        <div class="leftCaret" @click="changeArrow">
          <i
            :class="stateArrow ? 'el-icon-caret-left' : 'el-icon-caret-right'"
          ></i>
        </div>
      </div>
      <div class="tableStyle-right">
        <div class="carStateTable">
          <el-scrollbar>
            <div class="rightAll">
              <div class="rightAll-form">
                <el-form
                  :inline="true"
                  :model="formInline"
                  class="demo-form-inline"
                >
                  <el-form-item :label="$t('common.num')">
                    <el-select
                      v-model="formInline.selectCarType"
                      style="width: 120px"
                      :placeholder="$t('common.form.choseTip')"
                      class="selectStyle"
                    >
                      <el-option
                        v-for="item in optionsInput"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                    <el-input
                      size="mini"
                      v-model="formInline.selectCarValue"
                      :placeholder="$t('common.searchTip')"
                      style="width: 150px"
                      class="inputStyle"
                    ></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('common.terminalId')">
                    <el-input
                      size="mini"
                      v-model="formInline.terminalId"
                      :placeholder="$t('common.searchTip')"
                      style="width: 150px"
                      class="input-with-select"
                    ></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('common.linkState')">
                    <el-select
                      v-model="formInline.linkState"
                      :placeholder="$t('common.form.state')"
                      filterable
                      size="mini"
                      style="width: 120px; margin-left: 5px"
                    >
                      <el-option :label="$t('common.all')" value=""></el-option>
                      <el-option
                        :label="$t('common.onLine')"
                        value="1"
                      ></el-option>
                      <el-option
                        :label="$t('common.offLine')"
                        value="0"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('DriverManagement.authorizes')">
                    <el-input-number
                      size="mini"
                      v-model="formInline.authorizeCountLower"
                      controls-position="right"
                      :min="0"
                      :max="10000"
                    ></el-input-number>
                    <span>{{ $t("common.reach") }}</span>
                    <el-input-number
                      size="mini"
                      v-model="formInline.authorizeCountUpper"
                      controls-position="right"
                      :min="0"
                      :max="10000"
                    ></el-input-number>
                  </el-form-item>
                  <el-form-item>
                    <el-button
                      size="mini"
                      type="primary"
                      @click="onSearch"
                      class="btn-chaxun"
                      >{{ $t("common.btn.search") }}</el-button
                    >
                    <el-button size="mini" @click="onClear" class="btn-del">{{
                      $t("common.btn.cancel")
                    }}</el-button>
                  </el-form-item>
                </el-form>
              </div>
              <div class="rightAll-btn">
                <el-button
                  v-if="isPrimaryKey('ICEMPOWER_SYNCHRONOUS')"
                  type="text"
                  :disabled="selected.length != 1"
                  @click="Refresh"
                  >{{ $t("common.btn.sync") }}</el-button
                >
                <el-button
                  v-if="isPrimaryKey('ICEMPOWER_EMPTY')"
                  type="text"
                  :disabled="selected.length != 1"
                  @click="CancelSend"
                  >{{ $t("common.btn.clear") }}</el-button
                >
                <el-button
                  v-if="isPrimaryKey('ICEMPOWER_BATCHEMPOWER')"
                  type="text"
                  :disabled="selected.length != 1"
                  @click="synchro"
                  >{{ $t("DriverManagement.form.batchAuth") }}</el-button
                >
                <el-button
                  v-if="isPrimaryKey('ICEMPOWER_ADD')"
                  type="text"
                  @click="addSimple"
                  :disabled="selected.length != 1"
                  >{{ $t("DriverManagement.btn.addAuthorize") }}</el-button
                >
                <el-button
                  v-if="isPrimaryKey('ICEMPOWER_DOWN')"
                  type="text"
                  @click="downCar"
                  >{{ $t("common.btn.download") }}</el-button
                >
              </div>
              <i-table
                :list="list"
                :height="height"
                ref="carTable"
                @handleSelectionChange="handleSelectionChange"
                :options="option"
                :columns="columns"
                :operates="operates"
              ></i-table>
              <IPagination ref="page" @PageFun="changeSize"></IPagination>
            </div>
          </el-scrollbar>
        </div>
      </div>
      <el-dialog
        width="620px"
        :before-close="closeDia"
        class="addDialong"
        :title="$t('DriverManagement.btn.addAuthorize')"
        :visible.sync="dialogFormVisible"
        :close-on-click-modal="false"
      >
        <el-form :rules="rules" ref="form" :model="form">
          <el-form-item
            prop="terminalId"
            :label="$t('common.terminalId') + ':'"
            :label-width="formLabelWidth"
          >
            <el-input
              disabled
              v-model="form.terminalId"
              :placeholder="$t('common.form.terminalId')"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('DriverManagement.authorizePower') + ':'"
            :label-width="formLabelWidth"
            prop="authorizePower	"
          >
            <el-select
              v-model="form.authorizePower"
              :label="$t('DriverManagement.form.authorizePower') + ':'"
            >
              <el-option
                :label="$t('DriverManagement.normalAuthorize')"
                value="1"
              ></el-option>
              <el-option
                :label="$t('DriverManagement.adminAuthorize')"
                value="2"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$t('DriverManagement.authorizeDriver') + ':'"
            :label-width="formLabelWidth"
            prop="driverNum"
          >
            <el-select
              v-model="form.driverNum"
              filterable
              :filter-method="filterMethod"
              :placeholder="$t('DriverManagement.form.choseDriverNum')"
            >
              <el-option
                v-for="item in driveList"
                :key="item.driverNum"
                :label="item.name"
                :value="item.driverNum"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancle('form')">{{
            $t("common.btn.cancel")
          }}</el-button>
          <el-button size="small" type="primary" @click="submitForm('form')">{{
            $t("common.btn.confirm")
          }}</el-button>
        </div>
      </el-dialog>
      <el-dialog
        width="620px"
        :before-close="closeSyncDia"
        class="addDialong"
        :title="$t('DriverManagement.form.batchAuth')"
        :visible.sync="dialogSyncFormVisible"
        :close-on-click-modal="false"
      >
        <el-form :rules="SyncRules" ref="SyncForm" :model="SyncForm">
          <el-form-item
            prop="terminalId"
            :label="$t('common.terminalId') + ':'"
            :label-width="formLabelWidth"
          >
            <el-input
              disabled
              v-model="SyncForm.terminalId"
              :placeholder="$t('common.form.terminalId')"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('DriverManagement.fingerBankName') + ':'"
            :label-width="formLabelWidth"
            prop="fingerGroupId"
          >
            <el-select
              v-model="SyncForm.fingerGroupId"
              filterable
              :filter-method="filterFingerMethod"
              :placeholder="$t('DriverManagement.form.choseFingerNum')"
            >
              <el-option
                v-for="item in fingerList"
                :key="item.fingerGroupId"
                :label="item.fingerGroupName"
                :value="item.fingerGroupId"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="SyncCancle('SyncForm')">{{
            $t("common.btn.cancel")
          }}</el-button>
          <el-button
            size="small"
            type="primary"
            @click="submitSyncForm('SyncForm')"
            >{{ $t("common.btn.confirm") }}</el-button
          >
        </div>
      </el-dialog>
      <el-dialog
        width="1200px"
        :before-close="closeOperateDia"
        class="tableDialong"
        :title="$t('common.btn.operate')"
        :visible.sync="dialogOperateFormVisible"
        :close-on-click-modal="false"
      >
        <div class="zMsgSearch">
          <el-form :inline="true" :model="formTable" class="demo-form-inline">
            <el-form-item :label="$t('common.driverNum')">
              <el-input
                size="mini"
                v-model="formTable.driverNum"
                :placeholder="$t('common.searchTip')"
                style="width: 150px"
                class="input-with-select"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('common.driverName')">
              <el-input
                size="mini"
                v-model="formTable.driverName"
                :placeholder="$t('common.searchTip')"
                style="width: 150px"
                class="input-with-select"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                size="mini"
                type="primary"
                @click="Search"
                class="btn-chaxun"
                >{{ $t("common.btn.search") }}</el-button
              >
              <el-button size="mini" @click="Clear" class="btn-del">{{
                $t("common.btn.cancel")
              }}</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="zMsgBtn">
          <el-button
            type="text"
            :disabled="select.length == 0"
            @click="queryDetails"
            >{{ $t("common.btn.batchDelete") }}</el-button
          >
          <el-button type="text" @click="down">{{
            $t("common.btn.download")
          }}</el-button>
        </div>
        <div class="zMsgTable">
          <i-table
            :list="authorizeList"
            :height="authorizeHeight"
            ref="authorizeTable"
            @handleSelectionChange="handleAuthorizeChange"
            :options="option"
            :columns="authorizeColumns"
            :operates="authorizeOperates"
          ></i-table>
          <IPaginations
            ref="AuthorizePage"
            @PageFun="changeAuthorizeSize"
          ></IPaginations>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import ICEmpower from "./ICEmpower.js";
export default ICEmpower;
</script>

<style lang="less" scoped>
@import "../../../assets/styles/Style.less";
</style>
